import React from 'react';
import cn from 'classnames';

import styles from './Item.module.css';

const Item = ({ item, animate, delay }) => (
  <li
    className={cn(styles.item, 'relative mb-4 last:mb-0', { [`${styles.animate}`]: animate })}
    style={{ animationDelay: `${2500 + delay * 100}ms` }}
  >
    <span
      style={{ background: item.color }}
      className={`${styles.background} absolute top-0 left-0 bottom-0 block`}
    />
    <span className="font-code text-xs uppercase text-neutral-600 block mb-1">{item.title}</span>
    <span className="font-code text-xs text-black block">{item.value}</span>
  </li>
);

export default Item;
